import { api } from "../api/callApi";
import { urlServer, urlSitesService } from "../api/v1";
import { FISH_HEALTH } from "../varibles/constants";
import { IOperation, IServiceRequest, ISite, IUnitDisease, TOperation } from "../varibles/interface";

const urlBase = urlServer + '/site';

interface IUpdateWaitingUnitOfSite {
    site_id?: string
    is_waiting_unit?: boolean
    mortality_risk?: boolean
    unit_diseases?: {
        types: string[]
    }
    unit_ids?: string[]
}

interface IGetFishAmountOfUnit {
    start_time: number
    units: {
        id: string
    }[]
}

interface IGetUnitChart {
    id: string
    year: string
}

interface IDetail {
    id: string
    year: string
}

export interface ISiteExtend extends ISite {
    operations: TOperation[]
}

export interface IResponseUpdateUnit {
    id: string
    fish_health?: FISH_HEALTH | null
    unit_diseases?: IUnitDisease
}

export interface IResponseSummarySites {
    disease_map: { [key: string]: any }
    harvest_capacity: number
    harvest_sites: string[]
    harvest_units: string[]
    inactive_sites: string[]
    lice_sites: string[]
    lice_units: string[]
    local_disease_sites: string[]
    local_disease_units: string[]
    mortality_sites: string[]
    mortality_units: string[]
    overload_sites: string[]
    overload_units: string[]
    sites: {
        [key: string]: string
    }
    starving_units: { [key: string]: string[] }
    units: { [key: string]: string }
    unit_health_map: { [key: string]: string[] }
}

export const SiteService = {
    gets: () => api.get<ISite[]>(urlBase),
    getByAdmin: () => api.get<ISite[]>(urlBase + '/s'),
    addExternal: (site: ISite) => api.post<ISite[]>(urlBase, site),
    getForPlan: (abort?: AbortController) => api.get<{ sites: ISite[], harvests: any[] }>(urlBase + '/plan', { signal: abort?.signal }),
    getLocations: (abort?: AbortController) => api.put(urlBase + '/plan', {}, { signal: abort?.signal }),
    updateUnits: (body: IUpdateWaitingUnitOfSite) => api.post<IResponseUpdateUnit[]>(urlBase + '/setting/unit', body),
    getSimulation: () => api.get(urlSitesService + '/simulation'),
    updateSimulation: (body: any) => api.post(urlSitesService + '/simulation', body),
    getAmountOfUnit: (body: IGetFishAmountOfUnit) => api.post<{ id: string, fish_amount: number, avg_weight: number }[]>(urlBase + '/time', body),
    getUnitChart: (body: IGetUnitChart) => api.post(urlBase + '/chart', body),
    detail: (body: IDetail) => api.post<ISiteExtend>(urlBase + '/detail', body),
    getSiteOfOp: (body: {
        id: string,
        operation_id: string
    }) => api.post<ISiteExtend>(urlBase + '/chart/operation', body),
    overview: () => api.get(urlBase + '/overview'),
    fishGroup: () => api.get(urlBase + '/fish_group'),
    fishGroupChart: (params: { group_id: string }) => api.post(urlBase + '/fish_group/chart', params),
    summary: () => api.get<IResponseSummarySites>(urlBase + '/summary'),
    history: (body: { start_time: number, finish_time: number }) => api.put<{ operations: (IOperation & { site_ids?: string[] })[], sites: ISite[], before_count: boolean, after_count: boolean }>(urlBase + '/history', body),
    dashboard: () => api.get<{ operations: IOperation[] }>(urlBase + '/dashboard'),
    serviceRequest: (abort?: AbortController) => api.get<{ request_tabs: IServiceRequest[] }>(urlBase + '/request-tab', { signal: abort?.signal })
}